// @flow

import React from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- components
import AbstractComponent from 'components/AbstractComponent';
import FixedSubmitArea from 'PMT/components/form/FixedSubmitArea';

/**
* Abstract class.
* The following methods must be override:
* - haveModifications(): boolean {}
* - getDefaultState(): Object {}
* - onSubmit = (event) => {};
* - shouldDisableSubmit(): boolean {}
* Notes:
* If you use a <Switch /> you must had key={`${Math.random()}`}
* to force reload the component when we reset the form. Otherwise, it will infinite loop.
*/
class AbstractFormComponent extends AbstractComponent {

  // -- events

  onReset = () => {
    if (!_.isUndefined(this.props.onReset)) {
      this.props.onReset();
    } else {
      this.setState(this.getDefaultState());
    }
  };

  //  onSubmit = (event: Object) => {
  //    event.preventDefault();
  //    console.error('on submit must be override');
  //  };

  // -- utils
  getDefaultState(): Object {
    console.error('getDefaultState must be override');
    return {};
  }

  haveModifications(): boolean {
    console.error('have modifications must be override');
    return true;
  }

  shouldDisableSubmit(): boolean {
    return true;
  }

  // -- checkers
  checkRegex(regex, value) {
    return regex.test(value);
  }

  // -- renderers

  renderButtons() {
    let button = (
      <button
        className="btn btn-primary"
        onClick={(event) => { event.preventDefault(); this.onSubmit(event); }}
        type="submit"
      >
        {I18n.tr('components.form.save')}
      </button>
    );

    if (!this.haveModifications() || this.shouldDisableSubmit()) {
      button = (
        <button className="btn btn-primary" disabled>
          {I18n.tr('components.form.save')}
        </button>
      );
    }

    return (
      <div className="text-center top-buffer-50">

        {this.haveModifications() &&
          <button
            className="btn"
            onClick={(event) => { event.preventDefault(); this.onReset(event); }}
            type="reset"
          >
            {I18n.tr('components.form.cancel_modifications')}
          </button>
        }

        &nbsp;&nbsp;&nbsp;&nbsp;

        {button}
      </div>
    );
  }

  renderFixedButtons() {
    return (
      <FixedSubmitArea
        haveModifications={this.haveModifications()}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        shouldDisableSubmit={this.shouldDisableSubmit()}
      />
    );
  }

  render() {
    console.error('This method should be override.');

    return (null);
  }

}

export default AbstractFormComponent;
